const sleep = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

const sleepUntil = async (conditionFn, checkInterval = 200) => {
    if (typeof conditionFn !== 'function') {
        throw new Error('sleepUntil expects a function as first argument');
    }

    while (!conditionFn()) {
        await sleep(checkInterval);
    }
};

export {
    sleep,
    sleepUntil,
};
